var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocumentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.41
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    },
    fill: "none"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7301",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5702",
    d: "M17.397 11.2V7.028a2 2 0 00-.586-1.414l-2.828-2.828a2 2 0 00-1.414-.586H5.397a2 2 0 00-2 2v14a2 2 0 002 2h4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5703",
    d: "M6.397 8.2h8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5704",
    d: "M6.397 11.2h8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5705",
    d: "M6.397 14.2h2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5733",
    d: "M18.143 15.82a3.2 3.2 0 010 4.515 3.164 3.164 0 01-4.491 0 3.2 3.2 0 010-4.515 3.164 3.164 0 014.491 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5734",
    d: "M21.411 22.996l-2.8-2.8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5708",
    d: "M0 0h24v24H0z"
  }))));
}

export default SvgDocumentIcon;


//////////////////
// WEBPACK FOOTER
// ./src/icons/DocumentIcon.svg
// module id = 882
// module chunks = 101